export const VALIDATED_ID = 1;
export const CANCELLED_ID = 2;
export const PENDING_ID = 3;
export const UNPAID_ID = 4;